import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { enablePush, pushSupported } from "../lib/push";

export function NotificationPrompt({ orderToken = null, className = "" }) {
  const supported = pushSupported();
  const [perm, setPerm] = useState(supported ? Notification.permission : "unsupported");
  const [busy, setBusy] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (supported && Notification.permission === "granted") {
      enablePush({ orderToken, requestPermission: false }).catch(() => {});
    }
  }, [supported, orderToken]);

  if (!supported || perm === "granted" || perm === "denied" || perm === "unsupported" || dismissed) return null;

  const enable = async () => {
    setBusy(true);
    try {
      await enablePush({ orderToken });
      setPerm("granted");
      toast.success("Notifiche attivate");
    } catch (e) {
      setPerm(Notification.permission);
      toast.error(e?.message || "Impossibile attivare le notifiche");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`bg-[#FFF8E1] border-2 border-[#FFC400] rounded-2xl p-4 mt-4 flex items-center justify-between gap-3 ${className}`} data-testid="notification-prompt">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-10 h-10 shrink-0 rounded-xl bg-[#FFC400]/25 grid place-items-center text-[#b45309]"><BellRing size={20} /></span>
        <div className="min-w-0">
          <p className="font-semibold text-sm text-[#0B0B0D]">Attiva le notifiche</p>
          <p className="text-xs text-neutral-600">Ricevi gli aggiornamenti dell'ordine anche ad app chiusa.</p>
        </div>
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <Button onClick={enable} disabled={busy} className="rounded-full bg-[#FFC400] hover:bg-[#E6AC00] text-[#0B0B0D] font-semibold h-9" data-testid="notification-enable">{busy ? "Attivo…" : "Attiva"}</Button>
        <button onClick={() => setDismissed(true)} className="text-neutral-400 hover:text-neutral-600 p-1" data-testid="notification-dismiss"><X size={16} /></button>
      </div>
    </div>
  );
}
